/**
 * Every feature flag that exists, with the value used when a tenant's
 * config.json doesn't mention it. Add a flag here first, then override it per
 * tenant/environment in `saas/<Tenant>/config.json`.
 *
 **/
export const DEFAULT_FEATURES = {
  /** External "Energy Usage Data" link in the side nav. */
  energyUsageDataLink: true,
  /** Guided dashboard tour: the welcome banner, the "Take a Tour" tab and the tour itself. */
  tutorial: true,
  /** Route RUM telemetry through our own /api/rum-ingest proxy instead of hitting AWS directly. */
  rumProxyEnabled: false,
};

export type FeatureFlags = typeof DEFAULT_FEATURES;
